// extracted by mini-css-extract-plugin
export default {"container":"SG-z","header":"TG-z","details":"UG-z","link":"VG-z"};